import React from 'react';
import { Box, Typography } from '@mui/material';
import { displayText, phaseColor } from '../helpers';
import { launchColors } from '../launchTheme';

interface Props {
  phaseKey: string;
  name?: string | null;
  size?: 'small' | 'medium';
}

const PhaseChip: React.FC<Props> = ({ phaseKey, name, size = 'small' }) => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, minWidth: 0, maxWidth: '100%' }}>
    <Box component="span" aria-hidden sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: phaseColor(phaseKey), flexShrink: 0 }} />
    <Typography component="span" noWrap sx={{ fontSize: size === 'small' ? 12 : 13, color: launchColors.textSecondary, minWidth: 0 }}>
      {displayText(name || phaseKey)}
    </Typography>
  </Box>
);

export default PhaseChip;
